import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Bara laterala din dreapta (`#user-sidebar`) - `sidebar/Easeedesk::userTickets`
 * si `sidebar/Remote_control::tickets_{sent,running,failed,done}`,
 * `ticket_commands`, `summary_counter`. Capetele sunt in `UserSidebarController`.
 */

export interface SidebarTicket {
  ID: number
  subject: string
  status_name: string
  status_color: string
  type_name: string
  type_color: string
}

export type CommandState = 'sent' | 'running' | 'failed' | 'done'

export interface CommandTicket {
  ID: number
  subject: string
  type_name: string
  type_color: string
  success: number
  failed: number
  running: number
  sent: number
}

export interface TicketCommand {
  action_type: string
  command_name: string
  status: string
  response: string
}

export interface CommandsSummary {
  done: number
  failed: number
  running: number
  pending: number
}

export function sidebarTickets(page: number): Promise<SidebarTicket[]> {
  return apiGet<SidebarTicket[]>(`/sidebar/tickets/${page}`)
}

export function commandTicketsQuery(state: CommandState, page: number) {
  return queryOptions({
    queryKey: ['sidebar', 'remote-control', state, page],
    queryFn: () => apiGet<CommandTicket[]>(`/sidebar/remote-control/${state}/${page}`),
  })
}

export function ticketCommands(ticket: number): Promise<TicketCommand[]> {
  return apiGet<TicketCommand[]>(`/sidebar/remote-control/ticket/${ticket}/commands`)
}

export const commandsSummaryQuery = queryOptions({
  queryKey: ['sidebar', 'remote-control', 'summary'],
  queryFn: () => apiGet<CommandsSummary>('/sidebar/remote-control/summary'),
  refetchInterval: 60 * 1000,
})
